import { render, staticRenderFns } from "./RiskConferenceWarningAlwaysCreate.vue?vue&type=template&id=987d74f2&scoped=true&"
import script from "./RiskConferenceWarningAlwaysCreate.vue?vue&type=script&lang=js&"
export * from "./RiskConferenceWarningAlwaysCreate.vue?vue&type=script&lang=js&"
import style0 from "./RiskConferenceWarningAlwaysCreate.vue?vue&type=style&index=0&id=987d74f2&scoped=true&lang=css&"
import style1 from "./RiskConferenceWarningAlwaysCreate.vue?vue&type=style&index=1&id=987d74f2&lang=scss&scoped=true&"
import style2 from "./RiskConferenceWarningAlwaysCreate.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987d74f2",
  null
  
)

export default component.exports